module.exports = __webpack_public_path__ + "static/media/banner.5b833775.gif";